<div class="header">
    <h2>{{ 'predefinedPathways.modal.edit.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="predefined-pathways-edit-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'predefinedPathways.error.unavailable' | translate" />
} @else if (pathway(); as pathway) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
        <div class="section">
            <h2>{{ 'predefinedPathways.fieldset.basic' | translate }}</h2>
            <app-form-input
                [control]="form.controls.name"
                [label]="'predefinedPathways.form.name' | translate"
                inputId="name"
                testId="predefined-pathways-edit-name"
            />

            <app-form-textarea
                [control]="form.controls.description"
                [label]="'predefinedPathways.form.description' | translate"
                inputId="description"
                testId="predefined-pathways-edit-description"
            />

            <app-form-select
                [control]="form.controls.type"
                [label]="'predefinedPathways.form.type' | translate"
                [options]="typeOptions"
                inputId="type"
                testId="predefined-pathways-edit-type"
            />
        </div>

        <div class="section">
            <h2>{{ 'predefinedPathways.fieldset.assignment' | translate }}</h2>
            <app-form-multiselect
                [control]="form.controls.schoolIds"
                [label]="'predefinedPathways.form.schools' | translate"
                [options]="schoolOptions()"
                [filter]="true"
                inputId="schoolIds"
                testId="predefined-pathways-edit-school-ids"
            />

            <app-form-multiselect
                [control]="form.controls.organisationIds"
                [label]="'predefinedPathways.form.organisations' | translate"
                [options]="organisationOptions()"
                [filter]="true"
                inputId="organisationIds"
                testId="predefined-pathways-edit-organisation-ids"
            />
        </div>

        <div class="section">
            <app-predefined-pathway-course-list
                [courses]="selectedCourses()"
                (add)="openCourseDialog()"
                (remove)="removeCourse($event)"
                (reorder)="selectedCourses.set($event)"
            />
        </div>
    </form>

    <div class="footer">
        <p-button
            [label]="'predefinedPathways.form.cancel' | translate"
            [outlined]="true"
            severity="secondary"
            data-test="predefined-pathways-edit-cancel"
            (onClick)="close()"
        />
        <p-button
            type="submit"
            [label]="'predefinedPathways.form.save' | translate"
            [loading]="saving()"
            [disabled]="form.disabled"
            data-test="predefined-pathways-edit-save"
            (onClick)="onSubmit()"
        />
    </div>
}
